import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api/adminApi';
import { adminKeys } from '../api/adminQueryKeys';
export function useAdminPersonDetail(personId) {
    return useQuery({
        queryKey: adminKeys.personDetail(personId),
        queryFn: () => adminApi.getPersonDetail(personId),
        enabled: !!personId,
    });
}
